import api from "@/services/api";

import {
  SET_TRACKS,
  RENAME_TRACK,
  LIKE_TRACK,
  UNLIKE_TRACK,
  DELETE_TRACKS
} from "@/store/mutation-types";

export default {
  async fetch({ commit }, { type, params }) {
    const { payload = {} } = await api.tracks.fetch(type, params);
    const { tracks = [], track = {} } = payload;

    commit(
      SET_TRACKS,
      type === "track" || type === "editing" ? [track] : tracks
    );

    return payload;
  },
  async chart({ commit, dispatch }, { type, params }) {
    const { payload = {} } = await api.charts.fetch(type, params);
    const { tracks: tracksIds = [] } = payload;
    const { tracks = [] } = await dispatch("fetch", {
      params: { ids: tracksIds }
    });

    commit(SET_TRACKS, tracks);

    return payload;
  },
  async listened(ctx, id) {
    try {
      await api.tracks.listened(id);

      return true;
    } catch (error) {
      this.$app.$errorHandler.resolve(error);

      return false;
    }
  },
  async like({ commit, dispatch }, id) {
    try {
      commit(LIKE_TRACK, id);

      await api.tracks.like(id);

      return true;
    } catch (error) {
      commit(UNLIKE_TRACK, id);

      if (this.$app.$errorHandler.unauthorizedRequest(error)) {
        dispatch("modal/open", { name: "login" }, { root: true });
      } else {
        this.$app.$errorHandler.add(error);
      }

      return false;
    }
  },
  async unlike({ commit, dispatch }, id) {
    try {
      commit(UNLIKE_TRACK, id);

      await api.tracks.like(id);

      return true;
    } catch (error) {
      commit(LIKE_TRACK, id);

      if (this.$app.$errorHandler.unauthorizedRequest(error)) {
        dispatch("modal/open", { name: "login" }, { root: true });
      } else {
        this.$app.$errorHandler.add(error);
      }

      return false;
    }
  },
  async update({ commit }, params) {
    const { payload = {} } = await api.tracks.update(params);
    const { track = {} } = payload;

    commit(SET_TRACKS, [track]);

    return track;
  },
  async rename({ commit }, { id, title }) {
    try {
      commit(RENAME_TRACK, { id, title });
      return { id, title };
    } catch (error) {
      console.error(error);

      return false;
    }
  },
  async delete({ commit }, { ids }) {
    try {
      await api.tracks.delete({ ids });

      commit(DELETE_TRACKS, ids);

      return { ids };
    } catch (error) {
      console.error(error);

      return false;
    }
  }
};
